<template>
  <SideButtons :buttons="buttons" />
</template>

<script>
export default {
  props: {
    back: {
      type: Boolean,
      default: false
    },
    save: {
      type: Function,
      default: null
    }
  },
  data () {
    const data = {
      buttons: []
    }
    if (this.back)
      data.buttons.push({
        text: 'Назад',
        click: () => this.$router.go(-1)
      })
    if (this.save)
      data.buttons.push({
        text: 'Сохранить',
        click: this.save
      })
    return data
  }
}
</script>